import React from 'react'
import Img from 'gatsby-image'

const GrayBanner = ({ data }) => {
    const { content, logo, title, button } = data

    return (
        <section className="gray-banner">
            <div className="image-wrapper">
                {logo && (
                    <Img 
                        fluid={logo?.localFile?.childImageSharp?.fluid}
                    />
                )}
            </div>
            <div className="content-wrapper">
                {title && (
                    <h5>{title}</h5>
                )}
                {content && (
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                )}
                {button && (
                    <a className="btn button-outline-blue" href={button.url}>{button.title}</a>
                )}
            </div>
        </section>
    )
}

export default GrayBanner
